import { Component, inject, Input, OnInit } from '@angular/core';
import { SmallTuileComponent } from '../../../../../../../../components/ecosystems/small-tuile/small-tuile.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
  FunctionOnglet,
} from '../../../../../../manager/edro-network-manager';
import { IProduct, IProductFunctionnality } from '../../../../../IProduct';
import { TuileButtonProps } from '../../../../../../../../components/ecosystems/larged-tuile/larged-tuile.component';
import { getPoolMasterClass } from '../../../../../../ECoSystemsHelper';
import { P00031 } from '../../../../P00031';

@Component({
  selector: 'app-p00039-card-couverture-statut',
  templateUrl: './p00039-card-couverture-statut.component.html',
  styleUrls: ['./p00039-card-couverture-statut.component.scss'],
  imports: [SmallTuileComponent, TranslatePipe],
})
export class P00039CardCouvertureStatutComponent implements OnInit {
  private edroNetworkManager = inject(EdroNetworkManager);
  private translateService = inject(TranslateService);
  @Input() productClass: IProduct | null = null;
  public actionStack: DeviceActionStackService | null = null;

  public buttons: TuileButtonProps[] = [];

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );

    this.buttons = [
      {
        title: 'P00039.card.state.cover.title.open',
        icon: 'fa-kit fa-picto-couvfermeedeux',
        color: 'color-green',
        status: 'active',
      },
      {
        title: 'P00039.card.state.cover.title.close',
        icon: 'fa-kit fa-picto-couvouvertedeux',
        color: 'color-red',
        status: 'inactive',
      },
    ];
  }

  async openProductModal() {
    await this.edroNetworkManager.openProductModal(
      this.productClass!,
      IProductFunctionnality.COUVERTURE,
      FunctionOnglet.CONTROL,
      this.translateService.instant('dashboard.cover'),
    );
  }
}
